module.exports = [

    /**
     * Components
     */
    {
        title: "Components",
        icon: {
            name: "category"
        },
        entryCardText: "Find all currently available components here",
        path: "components",
        redirect: "components",
        appFolder: "ComponentsDocumentation",
        routes: [
            {
                title: "Overview",
                path: "components",
                rootPath: "/components/components",
                componentPath: "components/Components"
            },
            {
                title: "Accordion",
                path: "accordion",
                rootPath: "/components/accordion",
                componentPath: "components/Accordion",
                icon: "calendar_view_day",
                outlined: true,
                statusBadges: ["javascript"]
            },
            {
                title: "Action list",
                path: "action-list",
                rootPath: "/components/action-list",
                componentPath: "components/ActionList",
                icon: "list",
                statusBadges: ["javascript", "deprecated"],
                deprecated: true
            },
            {
                title: "Alerts",
                path: "alerts",
                rootPath: "/components/alerts",
                componentPath: "components/Alerts",
                icon: "error_outline",
                statusBadges: ["javascript"]
            },
            {
                title: "Badges",
                path: "badge",
                rootPath: "/components/badge",
                componentPath: "components/Badge",
                icon: "more",
                outlined: true
            },
            {
                title: "Breadcrumb",
                path: "breadcrumb",
                rootPath: "/components/breadcrumb",
                componentPath: "components/Breadcrumb",
                icon: "last_page",
                outlined: true
            },
            {
                title: "Buttons",
                path: "buttons",
                rootPath: "/components/buttons",
                componentPath: "components/Buttons",
                icon: "touch_app",
                statusBadges: ["updated"],
                outlined: true
            },
            {
                title: "Cards",
                path: "cards",
                rootPath: "/components/cards",
                componentPath: "components/Card",
                icon: "view_agenda",
                outlined: true
            },
            {
                title: "Charts",
                path: "charts",
                rootPath: "/components/charts",
                componentPath: "components/Charts",
                icon: "bar_chart",
                outlined: true,
                statusBadges: ["javascript", "deprecated"],
                deprecated: true
            },
            {
                title: "Checkbox",
                path: "checkbox",
                rootPath: "/components/checkbox",
                componentPath: "components/Checkbox",
                icon: "check_box",
                outlined: true,
                statusBadges: ["updated"]
            },
            {
                title: "Datepickers",
                path: "datepickers",
                rootPath: "/components/datepickers",
                componentPath: "components/Datepickers",
                icon: "event",
                outlined: true,
                statusBadges: ["javascript", "updated"]
            },
            {
                title: "Dialog",
                path: "dialog",
                rootPath: "/components/dialog",
                componentPath: "components/Dialog",
                icon: "picture_in_picture",
                outlined: true,
                statusBadges: ["javascript"]
            },
            {
                title: "Dropdown",
                path: "dropdown",
                rootPath: "/components/dropdown",
                componentPath: "components/Dropdown",
                icon: "expand_more",
                outlined: true,
                statusBadges: ["javascript", "updated"]
            },
            {
                title: "Expandable",
                path: "expandable",
                rootPath: "/components/expandable",
                componentPath: "components/Expandable",
                icon: "expand",
                statusBadges: ["javascript"]
            },
            {
                title: "Input field",
                path: "input-field",
                rootPath: "/components/input-field",
                componentPath: "components/InputField",
                icon: "text_fields",
                statusBadges: ["javascript", "updated"]
            },
            {
                title: "Links",
                path: "links",
                rootPath: "/components/links",
                componentPath: "components/Links",
                icon: "link",
                outlined: true
            },
            {
                title: "Lists",
                path: "lists",
                rootPath: "/components/lists",
                componentPath: "components/Lists",
                icon: "sort",
                outlined: true
            },
            {
                title: "Loader",
                path: "loader",
                rootPath: "/components/loader",
                componentPath: "components/Loader",
                icon: "loop",
                outlined: true
            },
            {
                title: "Media Object",
                path: "media-object",
                rootPath: "/components/media-object",
                componentPath: "components/MediaObject",
                icon: "account_circle",
                outlined: true
            },
            {
                title: "Navigation",
                path: "nav",
                rootPath: "/components/nav",
                componentPath: "components/Nav",
                icon: "explore",
                outlined: true,
                statusBadges: ["javascript", "deprecated"],
                deprecated: true
            },
            {
                title: "Pagination",
                path: "pagination",
                rootPath: "/components/pagination",
                componentPath: "components/Pagination",
                icon: "power_input",
                outlined: true,
                statusBadges: ["javascript"]
            },
            {
                title: "Panel",
                path: "panel",
                rootPath: "/components/panel",
                componentPath: "components/Panel",
                icon: "table_rows",
                outlined: true
            },
            {
                title: "Progress steps",
                path: "progress-steps",
                rootPath: "/components/progress-steps",
                componentPath: "components/ProgressSteps",
                icon: "hdr_strong"
            },
            {
                title: "Radio button",
                path: "radio-button",
                rootPath: "/components/radio-button",
                componentPath: "components/RadioButton",
                icon: "radio_button_checked",
                statusBadges: ["javascript", "updated"]
            },
            {
                title: "Rangeslider",
                path: "rangeslider",
                rootPath: "/components/rangeslider",
                componentPath: "components/Rangeslider",
                icon: "tune",
                outlined: true,
                statusBadges: ["javascript", "updated"]
            },
            {
                title: "Sheet",
                path: "sheet",
                rootPath: "/components/sheet",
                componentPath: "components/Sheet",
                icon: "vertical_split",
                outlined: true,
                statusBadges: ["javascript"]
            },
            {
                title: "Select",
                path: "select",
                rootPath: "/components/select",
                componentPath: "components/Select",
                icon: "arrow_drop_down_circle",
                outlined: true,
                statusBadges: ["updated"]
            },
            {
                title: "Sidebar",
                path: "sidebar",
                rootPath: "/components/sidebar",
                componentPath: "components/Sidebar",
                icon: "view_sidebar",
                outlined: true,
                statusBadges: ["javascript"]
            },
            {
                title: "Skip link",
                path: "skip-link",
                rootPath: "/components/skip-link",
                componentPath: "components/SkipLink",
                icon: "skip_next",
                outlined: true
            },
            {
                title: "Slab",
                path: "slab",
                rootPath: "/components/slab",
                componentPath: "components/Slab",
                icon: "crop_landscape",
                outlined: true
            },
            {
                title: "Status",
                path: "status",
                rootPath: "/components/status",
                componentPath: "components/Status",
                icon: "check_circle",
                outlined: true
            },
            {
                title: "Tables",
                path: "tables",
                rootPath: "/components/tables",
                componentPath: "components/Tables",
                icon: "view_list",
                outlined: true
            },
            {
                title: "Tabs",
                path: "tabs",
                rootPath: "/components/tabs",
                componentPath: "components/Tabs",
                icon: "folder",
                outlined: true,
                statusBadges: ["javascript"]
            },
            {
                title: "Tags",
                path: "tags",
                rootPath: "/components/tags",
                componentPath: "components/CodeTags",
                icon: "code",
                outlined: true
            },
            {
                title: "Toast",
                path: "toast",
                rootPath: "/components/toast",
                componentPath: "components/Toast",
                icon: "picture_in_picture",
                outlined: true,
                statusBadges: ["javascript"]
            },
            {
                title: "Togglebox",
                path: "togglebox",
                rootPath: "/components/togglebox",
                componentPath: "components/Togglebox",
                icon: "toggle_off",
                outlined: true
            },
            {
                title: "Tooltips",
                path: "tooltips",
                rootPath: "/components/tooltips",
                componentPath: "components/Tooltips",
                icon: "filter_frames",
                outlined: true,
                statusBadges: ["javascript"]
            },
            {
                title: "Topbar",
                path: "topbar",
                rootPath: "/components/topbar",
                componentPath: "components/Topbar",
                icon: "call_to_action",
                outlined: true,
                statusBadges: ["javascript"]
            }
        ]
    }
];
